import { render, staticRenderFns } from "./LinkRenderer.vue?vue&type=template&id=56f0a86e&scoped=true&"
var script = {}
import style0 from "./LinkRenderer.vue?vue&type=style&index=0&id=56f0a86e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f0a86e",
  null
  
)

export default component.exports